export const customClientFilters = {
  companyName: "COMP_NAME",
  taxId: "VAT_NO",
  zip: "ZIP",
  street1: "STR",
  state: "STATE",
  city: "CITY",
  legalForm: "LEGAL_FORM",
  registrationNumber: "REG_NO",
};
